import {h, Fragment} from "preact"
import { useState, useEffect } from "preact/hooks";
import { IconPlus, IconMinus } from "../icons"
import { getCookie, setCookie } from "../../utils"


export default function FacetPanel({ 
    panelName,
    showMoreButton,
    showAll, 
    onShowAllClick,
    className,
    children 
}) {

    const cookieKey = `facet_${panelName}`;
    const [activeSelect, setActiveSelect] = useState(false);

    // Load initial state from cookie
    useEffect(() => {
        const saved = getCookie(cookieKey);
        if (saved !== null) {
            setActiveSelect(saved === "true");
        }
    }, [cookieKey]);

    // Save to cookie whenever state changes
    useEffect(() => {
        setCookie(cookieKey, activeSelect);
    }, [activeSelect, cookieKey]);

    return (
        <div className={`panel-filters panel-facet ${className}`}>
            <div className="panel-header">
                <button
                    className="panel-trigger one-whole"
                    data-nosto-element="facet"
                    onClick={() => setActiveSelect(!activeSelect)}
                >
                    <div className="flex align-items-center justify-content-between">
                        <span className="small-label">{panelName}</span>
                        {activeSelect ? <IconMinus /> : <IconPlus />}
                    </div>
                </button>
            </div>
            <div className={`panel-inner ${!activeSelect && 'hide'}`}>
                {children}
                {showMoreButton && (
                    <button
                        className="flex align-items-center expander"
                        onClick={onShowAllClick}
                    >
                        {showAll ? <IconMinus /> : <IconPlus />}
                        {showAll ? "Show Less" : "Show More"}
                    </button>
                )}
            </div>
        </div>
    )
}